import { FC } from 'react';

export const PartnerInformation: FC = () => {
  return <section>Information</section>;
};
